import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useCoachFeedback from 'components/Common/Programs/Hooks/useCoachFeedback';
import ProgramIcon from 'components/Common/Programs/Widgets/Icon/Index';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';
import Form from './Form';

export default function Index() {
  const { programId } = useParams();
  const coachFeedback = useCoachFeedback(programId);

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'Ratings and feedback',
    },
  ];

  if (coachFeedback === null) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="content">
      {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <section>
        <h1 className="mb-5">Ratings and feedback</h1>

        <Row>
          <Col md={6}>
            <ProgramIcon
              program={{
                id: coachFeedback.attributes.coaching_plan_id,
                title: coachFeedback.attributes.coaching_plan,
              }}
            />
          </Col>

          <Col md={6} className="mt-3 mt-md-0">
            <CoachIcon
              coach={coachFeedback.attributes.coach}
              link={routes.coaches.show(coachFeedback.attributes.coach.id)}
            />
          </Col>
        </Row>
      </section>

      <section className="pb-0">
        <h3 className="mb-3">Initial Coach Feedback</h3>

        <p className="small fw-light text-gray-700">
          Please rate your coach on a scale of 1 - 5 Star. One being the lowest and five the highest rating.
        </p>
      </section>

      <Form coachFeedback={coachFeedback} />
    </div>
  );
}
